import React from "react";
import { Subidebarb } from "../../../../components/sidebar/MPOFKM/Sidebar";
import "./Aboutkm.css";

export const Aboutkm = () => {
  return (
    <div className="tns">
      <div className="tns-left">
        <Subidebarb />
      </div>

      <div className="tns-right">
        <div className="tns-heading">
          <span>Spectacular Kandhamal</span>
        </div>

        <div className="aboutkm-container">
          <p>
            Kandhamal Parliamentary Constituency is located in Boudh, Ganjam,
            Kandhamal & Nayagarh districts of Odisha. As per the estimates of
            2011 census, out of total 1701708 population 91.89% is rural and
            8.11% is urban population. The Scheduled castes (SC) and Scheduled
            tribes (ST) ratio is 19.73 and 29.91, respectively out of the total
            population. As per the voter list of 2019, there are 1259088
            electorates and 1563 polling stations in this constituency. Voter
            turnout in the 2019 Parliamentary election was 74.81% where as it
            was 73.43% in 2014 Parliamentary Election. The BJD, the BJP and the
            INC got 49.01%, 33.17% and 14.76% votes respectively in
            2019-parliamentary election while 50.21%, 12.95% and 28.64% in
            2014-parliamentary election respectively.
          </p>
          <span>
            “The health of a nation is defined by the quality of education.”
          </span>

          <div className="aboutkm-img">
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
          </div>

          <div className="tourism-potential">
            <span>Tourism Potential of Kandhamal</span>
            <p>
              The natural domain of Kandhamal district has its riches hidden
              from the public eye. The natural forest cover, the rivers and
              streams, a variety of animal life is exotic and exhilarating. The
              information, statistics and perspective of tourism in Kandhamal
              district have always been amusing and stimulating. There is no
              doubt that a good public transport system and matching
              infrastructure around the selected destinations can attract a lot
              of visitors both domestic as well as international.
            </p>
          </div>

          <div className="key-points">
            <span>Key Points</span>
            <div className="key-points-container">
              <div className="key-points-left">
                <ul>
                  <li>Ludu Waterfall</li>
                  <li>Putudi Waterfall</li>
                  <li>Kalinga Ghat, Silviculture Garden etc.</li>
                  <li>Phulbani, the Mystic River Salunki, Pilasaluki Dam</li>
                  <li>Pakadadarah Waterfall</li>
                </ul>
              </div>
              <div className="key-points-right">
                <ul>
                  <li>
                    The valley of Daringbadi, Pine Jungles, Coffe Plantations
                  </li>
                  <li>
                    The 2555ft elevation Forestland and Sanctuary of Belghar
                  </li>
                  <li>Katramal Waterfall and the flying fishes of its ponds</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="aboutkm-img">
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
          </div>

          <div className="aboutkm-only-span">
            <span>Agricultural Potential of Kandhamal</span>
          </div>

          <div className="aboutkm-img">
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
            <div className="aboutkm-img-container">
              <img src="" alt="" />
            </div>
          </div>
        </div>

        <div className="aboutkm-text-block-container">
          <div className="aboutkm-text-block">
            <span>Forest Product</span>
            <p>
              Kandhamal district has got 5709.83 Sq. Kms. of forest area which
              is 71% of the total geographical area of the district. The
              bounties of nature has endowed the district with rich forest
              abound in Sal, Sisal, Bija, Asana etc with some precious varieties
              like Sandalwood etc. Forest produce of economic importance of the
              district mainly consists of Bamboo, Kendu Leaf, Tamarind, Mahua
              Flower and Seeds, Sal Seeds etc.
            </p>
          </div>

          <div className="aboutkm-text-block">
            <span>Other Produce</span>
            <p>
              Paddy, Vegetables, Maize, Mustard, Ginger, Horse Gram and Turmeric
              are the principal crops. The district is known for cultivating a
              variety of vegetables and spices organically. The favourable
              agro-climatic conditions of the district promote the cultivation
              of horticulture crops such as Mango, Banana, Guava, Papaya and
              Jackfruit. The district has a conducive climate for vegetable
              production. As the district enjoys a low temperature throughout
              the year, it is suitable for vegetable production like Cabbage,
              Beans, Cauliflower etc. in off seasons.
            </p>
          </div>

          <div className="aboutkm-text-block">
            <span>Medicinal & Organic Produce</span>
            <p>
              The district is very suitable for cultivation of medicinal plants
              and organic spices like turmeric and ginger. The district is by
              default, organic. Kandhamal occupies a unique position in spice
              production in the state. The tribal of the district are
              traditionally grow turmeric and ginger organically from ages,
              which is the main cash crop for their economic development.Once
              good connectivity and transportation system such as a Rail Network
              is provided, Kandhamal has the potential to become the Organic
              Crop production hub of Odisha and even that of India.
            </p>
          </div>

          <div className="aboutkm-text-block">
            <span>Value addition & scope of Agro Processing</span>
            <p>
              The district has a very good scope for value addition and food
              processing, as a lot of vegetable and spices are grown in the
              district.
            </p>

            <p>
              These are the upcoming sectors which have the potential to
              generate lot of employment opportunities in the rural areas.
              Unfortunately, in Kandhamal this potential has not been properly
              exploited. The food processing industry is not that well developed
              and is limited to grain processing like rice mills, flour mill and
              turmeric processing plant.
            </p>
          </div>


        </div>

        <div className="aboutkm-block-btn">
            <button className="aboutkm-button">More About Kandhamal</button>
          </div>


          <div className="aboutkm-mpreport">
        <div className="mp-report-text">
          <span>MP REPORTS</span>
          <p>View / Download Reports</p>
        </div>
        <div className="mp-report-img">
          <img src="" alt="" />
        </div>
      </div>
      </div>


    </div>
  );
};
